import React, { useState } from "react";
import styled from "styled-components";
import { FaCheck } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getTvodResponseByCountry,
  getResponseByCoupon,
} from "../redux/payment/payment.slice";
import LoadingDots from "../components/InlineLoader";
import {
  postSsl,
  postCouponSubscription,
} from "../redux/subscription/subscription.utils";
import { LoaderCircle } from "../components/styled/loaders";
// import PlayTrailer from "../components/PlayTrailer";
import { getContentById } from "../redux/payment/payment.utils";
import Modal from "../components/Modal";
import { Box } from "../components/styled/box";
import iscreenPaymentbgImage from "../assets/iscreen_payment_page_bg.jpg";
import urduflixPaymentbgImage from "../assets/urduflix_payment_page_bg.png";
import defaultPaymentbgImage from "../assets/default_payment_page_bg.png";
import {
  Container,
  Wrapper,
  PackagesContainer,
  SinglePackage,
  Header,
  ListContainer,
  List,
  ActivePayment,
  BgContainer,
} from "./styles/Payment.style";
// import checkbox from "../assets/checkbox_small.svg";
import checkboxChecked from "../assets/checkbox_checked_red.svg";
import { getCookie, getDomainName, getUserType } from "../utils/helpers";
import jwtDecode from "jwt-decode";

const TvodPaymentPage = () => {
  const iconLogo = window?.platform_info?.logo;
  const dispatch = useDispatch();
  const [tvodPackage, setTvodPackage] = useState({
    name: "",
    price: "",
    unit: "",
  });
  const [activeMethods, setActiveMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [postLoading, setPostLoading] = useState(false);
  const [contentInfo, setContentInfo] = useState({});
  // const [country, setCountry] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const hashValue = getCookie("hash");
  const decodedToken = hashValue && jwtDecode(hashValue);

  const {
    tvodItems,
    location,
    loading,
    couponStatus,
    couponLoading,
    couponMessage,
  } = useSelector((state) => state.payment);

  const isCoupon = selectedMethod?.type === "coupon";
  // when coupon is selected, CONTINUE stays disabled until a code is validated
  const isContinueDisabled = isCoupon && couponStatus !== "true";
  // const { theme } = useSelector((state) => state.theme);
  const theme = "dark";
  const {
    state: { cid, tvod },
  } = useLocation();

  console.log("ALl tvod items", tvodItems);

  const [localContentId] = useState(cid || localStorage.getItem("contentId"));
  const [localIsTvod] = useState(tvod || localStorage.getItem("isTvod"));

  // React.useEffect(() => {
  //   dispatch(getLocation());
  // }, [dispatch]);

  // runs only when country code fetched through location api
  React.useEffect(() => {
    if (location.countryCode) {
      dispatch(
        getTvodResponseByCountry({
          localContentId,
          country: location.countryCode,
          localIsTvod,
        }),
      );
    }
  }, [dispatch, location.countryCode, localContentId, localIsTvod]);

  // This effect runs only when tvod packages fetched successfully through api
  // Manipulating Package data for rendering
  React.useEffect(() => {
    let paymentMethods;
    if (tvodItems && tvodItems.items && tvodItems.items[0]) {
      paymentMethods = tvodItems.items[0].paymentMethods;
    }
    if (paymentMethods) {
      let allMethods = Object.values(paymentMethods ?? {});

      const activeMethods = allMethods.flatMap((method) =>
        Array.isArray(method) ? method : [],
      );

      setTvodPackage({
        name: tvodItems.items[0].name,
        price: tvodItems.items[0].price,
        unit: tvodItems.items[0].unit,
      });
      setActiveMethods(activeMethods);
      setSelectedMethod(activeMethods[0]);
    }
  }, [tvodItems]);

  // Get content for playing trailer
  React.useEffect(() => {
    getContentById(localContentId).then((res) => {
      setContentInfo({
        contentTitle: res?.data.title,
        hasTrailer: res?.data.trailer,
        trailerPath: res?.data.trailerPath,
        slug: res?.data.slug,
      });
    });
  }, [localContentId]);

  const handleSubmit = async () => {
    const platform = localStorage.getItem("platform");
    const reference = localStorage.getItem("reference");

    if (
      !selectedMethod ||
      selectedMethod === "undefined" ||
      selectedMethod === "null"
    ) {
      setOpenModal(true);
      setModalContent("You have not selected a payment method!");
    } else {
      setPostLoading(true);
      // from promotional link
      if (reference === "fb-promotion") {
        window.location.href = `https://${platform}?ref=paymentlanding&tvod=true&cid=${localContentId}&slug=${contentInfo?.slug}&package=${selectedMethod?.type}&product=${selectedMethod?.productId}`;
      } else if (isCoupon) {
        // coupon flow
        try {
          const response = await postCouponSubscription(
            promoCode,
            selectedMethod?.productId,
          );
          setPostLoading(false);
          // open to the api response's message field (redirect url)
          response?.data?.message &&
            window.location.replace(response.data.message);
        } catch (error) {
          setPostLoading(false);
          setOpenModal(true);
          setModalContent(
            error?.response?.data?.message ||
              "Something went wrong. Please try again.",
          );
        }
      } else {
        const userIdentity = decodedToken?.username;
        const paymentMethod = selectedMethod?.type;
        const userType = getUserType(userIdentity);

        // robi and cirkle block if not dsdb
        if (
          !["cirkle", "robi"].includes(userType) &&
          paymentMethod === "robi_dsdb"
        ) {
          setPostLoading(false);
          setOpenModal(true);
          setModalContent(
            "Robi Payment is available only for Robi or Cirkle User!",
          );
          return;
        }
        // gp block if not gpdcb
        if (!["gp"].includes(userType) && paymentMethod === "gpdcb") {
          setPostLoading(false);
          setOpenModal(true);
          setModalContent(
            "Grameenphone Payment is available only for Gp User!",
          );
          return;
        }
        // normal flow
        const response = await postSsl(
          selectedMethod?.type,
          selectedMethod?.productId,
        );
        setPostLoading(false);
        if (response.status === 400) {
          console.log("Handle Message for 400");
          setOpenModal(true);
          setModalContent(response?.data?.message);
        } else {
          response.data && window.location.replace(response.data?.message);
        }
      }
    }
  };

  const closeModal = () => {
    setOpenModal(false);
    setModalContent("");
  };

  const handlePromo = () => {
    if (promoCode && promoCode.length > 4) {
      dispatch(
        getResponseByCoupon({
          couponCode: promoCode,
          productId: selectedMethod?.productId,
        }),
      );
    } else {
      console.error("No Promo code Applied");
    }
  };

  const getBackgroundImage = () => {
    const platform = localStorage.getItem("platform");
    const brandName = getDomainName(platform);
    console.log("Platform from localstorage", brandName);
    if (brandName === "urduflix") {
      return urduflixPaymentbgImage;
    }
    if (brandName === "iscreen" || "funprime" || "bingepluslive") {
      return iscreenPaymentbgImage;
    }

    return defaultPaymentbgImage;
  };

  if (loading) {
    return <LoadingDots />;
  }

  return (
    <Container>
      <div>
        <Modal isOpen={openModal} onClose={closeModal}>
          <p>{modalContent}</p>
        </Modal>
      </div>
      <BgContainer $bgImage={getBackgroundImage()}></BgContainer>
      <Wrapper theme={theme}>
        <Header>
          <Box>
            <img
              src={iconLogo}
              style={{ height: "58px", marginBottom: "10px" }}
              alt=""
            />
          </Box>
        </Header>

        {postLoading ? (
          <LoaderCircle style={{ width: "55px", height: "55px" }} />
        ) : (
          <PackagesContainer>
            {/* <div>
              {contentInfo?.hasTrailer && (
                <PlayTrailer trailerPath={contentInfo?.trailerPath} />
              )}
            </div> */}
            <SinglePackage active={true} className="only-packages">
              <div className="left">
                <Box>
                  <div className="title">{localContentId === "13187" ? "ASEAN Cup Pass" : tvodPackage.name}</div>
                  <ListContainer>
                    {localContentId === "13187" ? (
                      <>
                        <List>
                          <FaCheck /> <span>Access All ASEAN Cup Matches only</span>
                        </List>
                        <List>
                          <FaCheck /> <span>Watch Across web, Mobile &amp; TV</span>
                        </List>
                        <List>
                          <FaCheck /> <span>Enjoy on Up to 4 Devices</span>
                        </List>
                      </>
                    ) : (
                      <>
                        <List>
                          <FaCheck /> <span>{tvodPackage.name} Subscription</span>
                        </List>
                        <List>
                          <FaCheck /> <span> Ad free experience</span>
                        </List>
                        <List>
                          <FaCheck />{" "}
                          <span>Access from all android, iOS and TV app</span>
                        </List>
                      </>
                    )}
                  </ListContainer>
                </Box>
              </div>
              <div className="right">
                <img src={checkboxChecked} alt="tvod Checked" />
                <div className="price">
                  <p className="currency">
                    <span className="sale-price">
                      <span>{tvodPackage.price}</span>{" "}
                      <span>{tvodPackage.unit}</span>
                    </span>
                  </p>
                </div>

                {/* <Button
                      variant="primary"
                      className="buy-btn"
                      onClick={() => handleBuyNowClick(item.id)}
                    >
                      Buy Now
                    </Button> */}
              </div>
            </SinglePackage>

            <SinglePackage className="only-methods">
              <div className="heading">
                <div className="title">Pay By</div>
              </div>
              <div className="divider"></div>
              <div className="all-methods">
                {activeMethods?.length > 0 ? (
                  activeMethods?.map((innerItem, index) => {
                    return (
                      <ActivePayment
                        key={index}
                        $isCoupon={
                          innerItem?.type === "coupon" &&
                          selectedMethod?.type === "coupon"
                        }
                        // onClick={() => handleSubmit(innerItem)}
                      >
                        <div className="radio-input-div">
                          <input
                            type="radio"
                            name="paymentMethodGroup" // Same name for all in the group
                            id={innerItem?.type}
                            value={innerItem?.type}
                            checked={selectedMethod?.type === innerItem?.type}
                            onChange={(e) => setSelectedMethod(innerItem)}
                            className="custom-radio"
                          />
                        </div>
                        <label htmlFor={innerItem?.type}>
                          <div className="wrap">
                            <img
                              className="sslImage"
                              src={`https://img.rockstreamer.com/https://graphic.rockstreamer.com/${innerItem.operatorLogo}`}
                              alt={innerItem?.type}
                            />
                            {/* <div className="text">
                            <div>{innerItem?.operatorName}</div>
                            <span>{innerItem?.operatorAdditional}</span>
                          </div> */}
                          </div>
                        </label>
                        {innerItem?.type === "coupon" &&
                          selectedMethod?.type === "coupon" && (
                            <>
                              <PromoWrap couponStatus={couponStatus}>
                                {couponStatus === "true" ? (
                                  <span className="coupon-message success">
                                    {couponMessage ||
                                      "You have got discount on this package"}
                                  </span>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      name="promo"
                                      id="promo"
                                      value={promoCode}
                                      onChange={(e) =>
                                        setPromoCode(e.target.value)
                                      }
                                      placeholder="Enter promo code if any"
                                      autoComplete="off"
                                      disabled={couponLoading}
                                    />
                                    <button
                                      type="button"
                                      className="apply-btn"
                                      onClick={handlePromo}
                                      disabled={couponLoading || !promoCode}
                                    >
                                      {couponLoading ? "..." : "APPLY"}
                                    </button>
                                  </>
                                )}
                              </PromoWrap>
                              {couponStatus === "false" && (
                                <PromoMessage>
                                  {couponMessage || "Invalid coupon code"}
                                </PromoMessage>
                              )}
                            </>
                          )}
                      </ActivePayment>
                    );
                  })
                ) : (
                  <div className="no-payment-found">
                    No Payment Methods Found!
                  </div>
                )}
              </div>
            </SinglePackage>
            <SinglePackage className="only-payment-summary desktop">
              <div className="title">Payment Summary</div>
              <div className="divider"></div>
              <div className="all-summaries">
                <div className="total">
                  <div>Total</div>
                  <div>
                    {isCoupon ? 0 : tvodPackage.price} {tvodPackage.unit}
                  </div>
                </div>
                <div className="total-payable">
                  <div>Total Payable</div>
                  <div>
                    {isCoupon ? 0 : tvodPackage.price} {tvodPackage.unit}
                  </div>
                </div>
              </div>
              <div
                className={`pay-btn${isContinueDisabled ? " disabled" : ""}`}
                onClick={isContinueDisabled ? undefined : handleSubmit}
              >
                CONTINUE
              </div>
            </SinglePackage>
            <SinglePackage className="only-payment-summary mobile">
              <div className="transition-wrapper">
                <div className="bg-gradient"></div>
                <section className="contents">
                  <div className="title">Payment Summary</div>
                  <div className="divider"></div>
                  <div className="all-summaries">
                    <div className="total">
                      <div>Total</div>
                      <div>
                        {isCoupon ? 0 : tvodPackage.price} {tvodPackage.unit}
                      </div>
                    </div>
                    <div className="total-payable">
                      <div>Total Payable</div>
                      <div>
                        {isCoupon ? 0 : tvodPackage.price} {tvodPackage.unit}
                      </div>
                    </div>
                  </div>
                  <div className="pay-btn" onClick={handleSubmit}>
                    CONTINUE
                  </div>
                </section>
              </div>
            </SinglePackage>
          </PackagesContainer>
        )}
      </Wrapper>
    </Container>
  );
};

const PromoWrap = styled.div`
  display: flex;
  align-items: center;
  flex-basis: 100%;
  width: 100%;
  margin-top: 0.9rem;
  height: 3rem;
  border: 2px solid
    ${(props) => (props.couponStatus === "true" ? "green" : "var(--button-bg)")};
  border-radius: 8px;
  overflow: hidden;
  background: var(--white);

  input[type="text"] {
    flex: 1;
    min-width: 0;
    height: 100%;
    padding: 0 1rem;
    border: none;
    outline: none;
    font-size: 0.9rem;
    color: var(--black);
    background: var(--white);
  }
  input[type="text"]::placeholder {
    color: var(--silver);
  }

  .apply-btn {
    height: 100%;
    padding: 0 2rem;
    border: none;
    outline: none;
    background: var(--button-bg);
    color: var(--button-front);
    font-weight: 700;
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    cursor: pointer;
    transition: background 250ms ease-in-out;
  }
  .apply-btn:hover {
    background: var(--button-hover);
  }
  .apply-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .coupon-message {
    flex: 1;
    padding: 0 1rem;
    font-size: 0.85rem;
    font-weight: 500;
  }
  .coupon-message.success {
    color: green;
  }

  @media (max-width: 600px) {
    width: 100%;
    .apply-btn {
      padding: 0 1.4rem;
      font-size: 0.8rem;
    }
  }
`;

const PromoMessage = styled.p`
  flex-basis: 100%;
  width: 100%;
  margin-top: 0.4rem;
  text-align: left;
  font-size: 0.8rem;
  color: var(--button-bg);
`;

export default TvodPaymentPage;
